import img from "../../../assets/images/opd_detail.png";
import MainButton from "../../../components/button/mainButton";
import HeaderBar from "../../../components/header/headerBar";
const UploadOPD = () => {
  return (
    <div>
      <HeaderBar btnBack={true} title="น.ส.รังสิมา แซ่หว่าง (EK-CNT60100015)">
        <MainButton title="Upload OPD" />
      </HeaderBar>
      <div style={{ padding: "0px 40px", margin: "10px 40px" }}>
        <div className="justify-center mt-20">
          <img src={img} />
        </div>
      </div>
    </div>
  );
};
export default UploadOPD;
